export default "__VITE_ASSET__KUiThXuB__"